const mappings = {
    ADD_ITEM_ERROR: 'shoppingbag_add_item_error',
    GET_PRODUCT_LIST_ERROR: 'product_list_error_retrieve',
    GET_PRODUCT_DATA_ERROR: 'product_data_error_retrieve',
    GET_PRODUCT_STOCK_ERROR: 'product_stock_error_retrieve',
    SAVE_QUANTITY_CHANGE_ERROR: 'quantity_change_error_save',
    REMOVE_FROM_CART_ERROR: 'product_error_remove',
    GET_STORES_ERROR: 'stores_error_retrieve',
};

export const getTextKey = (event) => {
    if (mappings.hasOwnProperty(event)) {
        return mappings[event];
    }
    return null;
};

export const getAllTextNotifications = () => {
    return mappings;
};
